<template>
  <CatalogCrudView
    title="Tipos de cobrança"
    subtitle="Classifique como as cobranças são materializadas para pagamento."
    singular="tipo de cobrança"
    list-title="Tipos de cobrança cadastrados"
    icon="receipt"
    :service="service"
    :fields="fields"
    :columns="columns"
    :form-defaults="formDefaults"
  />
</template>

<script>
import CatalogCrudView from '../components/CatalogCrudView.vue'
import service from '../services/chargeTypeService'

export default {
  name: 'ChargeTypesView',
  components: { CatalogCrudView },
  data: () => ({
    service,
    formDefaults: { name: '', code: '', isActive: true },
    fields: [
      { key: 'name', label: 'Nome', required: true, maxlength: 100, placeholder: 'Ex.: Boleto', span: 7 },
      { key: 'code', label: 'Código', required: true, maxlength: 30, placeholder: 'Ex.: BOLETO', uppercase: true, span: 3 },
      { key: 'isActive', label: 'Situação', type: 'select', span: 2, options: [{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }] }
    ],
    columns: [
      { text: 'Id', value: 'id' }, { text: 'Nome', value: 'name', emphasis: true },
      { text: 'Código', value: 'code', type: 'code' }, { text: 'Situação', value: 'isActive', type: 'status' },
      { text: 'Criado em', value: 'createdAt', type: 'date' }
    ]
  })
}
</script>
